import { render, staticRenderFns } from "./lrDataBoard.vue?vue&type=template&id=836a0bd0"
import script from "./lrDataBoard.vue?vue&type=script&lang=js"
export * from "./lrDataBoard.vue?vue&type=script&lang=js"
import style0 from "./lrDataBoard.vue?vue&type=style&index=0&id=836a0bd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports